/**
 * **MARS 인용 필드의 구분자 — 정본 하나.** 엔진 토크나이저는 `"` 또는 `'` 로 시작하는 워드를 인용 필드로 읽는다(Envrl/cvic.f90:180). 덱 판독·
 * 값 풀기·편집 병합(`domain/mars/input/deck`)과, 카드에 따옴표 없이 실리는 이름의 규칙(`namePolicy.checkMarsCardName` — 그 구분자로 시작하는
 * 이름은 엔진이 닫히지 않은 인용 워드로 읽어 카드를 거절한다)이 이 하나를 읽는다. 진입 청크가 읽는 이름 규칙도 쓰므로 `domain/mars` 를
 * 가져오지 않는 이 모듈에 둔다.
 */
const QUOTE_DELIMITERS: readonly string[] = ['"', "'"];

/** 인용 필드의 구분자인가 */
export const isQuoteDelimiter = (ch: string | undefined): boolean => ch !== undefined && QUOTE_DELIMITERS.includes(ch);

/** 인용 구분자로 시작하는 워드(인용 필드)인가 */
export const startsQuoted = (raw: string): boolean => isQuoteDelimiter(raw[0]);

/** 사용자에게 보이는 구분자 목록 — `" '` */
export const QUOTE_DELIMITER_TEXT = QUOTE_DELIMITERS.join(' ');
